import {createApp} from 'vue'
import Store from 'store'
import ProductDetailTablist from './ProductDetailTablist'

const component = createApp(ProductDetailTablist).use(Store)

const el = '.nlx-component--product-detail-tablist'
const DOM = document.querySelector(el)


const scrapeDOMToGenerateData = (tabButtons, tabData) => {
    const data = []
    
    tabButtons.forEach((button, index) => {
        data.push({
            tabButtonTitle : button.innerText,
            isSelected : !!(index === 0),
            tabContentData : tabData[index] ? tabData[index].innerHTML : ""
        })
    })

    return data
}

if(DOM){

    const tabButtons = Array.from(DOM.querySelectorAll('.nlx-product-detail-tablist__tab-buttons button'))
    const tabData = Array.from(DOM.querySelectorAll('.nlx-product-detail-tablist__tab-container'))

    if (tabButtons && tabData) {
        Store.commit("productDetails/set_scraped_tablist_data", scrapeDOMToGenerateData(tabButtons, tabData))
    }
    
    component.mount(el)
}

